import { useState, type ReactNode } from 'react';
import type { RenderBreakdown, Span } from './spans';

/**
 * The columns a usage chart has picked (a click, Enter, a drag or Shift and an arrow) and the detail
 * behind them, which the page draws under the chart; nothing is picked without a detail to show.
 */
export function usePicked(
  render: RenderBreakdown | undefined,
  spanOf: (from: number, to: number) => Span,
) {
  const [picked, setPicked] = useState<{ from: number; to: number } | null>(null);
  // A pick from before the columns changed is dropped rather than read past the end.
  const detail: ReactNode =
    picked && render ? render(spanOf(picked.from, picked.to), () => setPicked(null)) : null;
  return {
    picked,
    detail,
    onSelect: render ? (i: number) => setPicked({ from: i, to: i }) : undefined,
    onSpan: render ? (from: number, to: number) => setPicked({ from, to }) : undefined,
  };
}
